const testimonials = [
  {
    name: '冒险者小星',
    role: '资深玩家',
    content: '重生萝莉岛是我玩过最有深度的冒险游戏！这里的攻略内容帮了我很多，每次卡关都能在这里找到解决方案。强烈推荐给所有新手！',
    rating: 5,
  },
  {
    name: '樱花下的约定',
    role: '剧情爱好者',
    content: '作为一个剧情党，重生萝莉岛的剧情解析文章真的太棒了。每一篇都写得非常用心，让我对游戏有了更深的理解。',
    rating: 5,
  },
  {
    name: '月下独行',
    role: '攻略作者',
    content: '从读者变成了内容创作者，重生萝莉岛给了我一个分享经验的平台。这里的社区氛围真的很好，大家都很有爱。',
    rating: 5,
  },
  {
    name: '风之旅人',
    role: '新手冒险者',
    content: '刚入坑的时候完全不知道该怎么玩，看了新手攻略之后豁然开朗。现在我已经是40级的冒险者啦！感谢重生萝莉岛！',
    rating: 5,
  },
  {
    name: '星尘魔法师',
    role: '考据党',
    content: '世界观设定解析的文章质量非常高，每一篇都考据详实。对于喜欢研究游戏背景的玩家来说，简直是宝藏平台。',
    rating: 5,
  },
  {
    name: '桃之夭夭',
    role: '角色厨',
    content: '角色图鉴做得太用心了！每个角色的背景故事、技能介绍、羁绊剧情都整理得清清楚楚。终于有人做了我一直想要的内容！',
    rating: 5,
  },
];

export default function Reputation() {
  return (
    <section id="reputation" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
            冒险者口碑
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            来自冒险者们的真实评价，每一份认可都是我们前进的动力
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-background-50 rounded-xl p-6">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">&ldquo;{t.content}&rdquo;</p>
              <div>
                <div className="font-medium text-foreground-900 text-sm">{t.name}</div>
                <div className="text-xs text-foreground-500">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}